import { Container, Text } from 'pixi.js';
import { outQuint } from '../util';

class VanishTitle extends Container {
  private dt: number = 0;
  private maxDT: number = 50;
  private processingType: number = 2;
  private title: Text;

  constructor(fontFamily: string = 'ff-providence-sans-web-pro, sans-serif') {
    super();
    this.title = new Text('', {
      fontSize: 110,
      fontWeight: '700',
      fontFamily,
      fontStyle: 'normal',
      stroke: 0xffffff,
      fill: '0x4a282f',
      align: 'center',
      strokeThickness: 20,
      padding: 20,
    });
    this.title.anchor.set(0.5, 0.5);
    this.addChild(this.title);
  }

  public setTitle(title: string) {
    this.title.text = title;
  }

  public setMaxDT(maxDT: number) {
    this.maxDT = maxDT;
  }

  public initialize(): void {
    this.dt = 0;
    this.processingType = 0;
  }

  public update(elapsed: number): void {
    if (this.dt <= this.maxDT) {
      this.dt += elapsed;
    }

    if (this.dt >= this.maxDT && this.processingType <= 2) {
      this.dt = 0;
      this.processingType++;
    }

    switch (this.processingType) {
      case 0:
        this.title.alpha = outQuint(this.dt / this.maxDT) * 1;
        this.title.x = 20 - outQuint(this.dt / this.maxDT) * 20;
        break;
      case 2:
        this.title.alpha = 1 - outQuint(this.dt / this.maxDT) * 1;
        this.title.x = -outQuint(this.dt / this.maxDT) * 20;
        break;
      default:
        break;
    }
  }
}

export default VanishTitle;
